import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

import { useAuth } from '../auth/AuthContext';
import ApprovalAccessCard from './approval-workflow/ApprovalAccessCard';
import ApprovalAuditFilterCard from './approval-workflow/ApprovalAuditFilterCard';
import ApprovalAuditLogCard from './approval-workflow/ApprovalAuditLogCard';
import ApprovalCreateCard from './approval-workflow/ApprovalCreateCard';
import ApprovalFeedbackSnackbar from './approval-workflow/ApprovalFeedbackSnackbar';
import ApprovalInboxCard from './approval-workflow/ApprovalInboxCard';
import ApprovalRequestsCard from './approval-workflow/ApprovalRequestsCard';
import useApprovalWorkflowData from './approval-workflow/useApprovalWorkflowData';

export default function ApprovalWorkflow() {
    const { hasPermission } = useAuth();
    const canView = hasPermission?.('approval:read');
    const canDecide = hasPermission?.('approval:write');

    const {
        inbox,
        requests,
        statusFilter,
        auditEntries,
        auditFilter,
        form,
        feedback,
        closeFeedback,
        handleFormChange,
        handleCreate,
        handleDecision,
        handleStatusFilterChange,
        handleAuditFilterChange,
        refreshAudit,
        resetAuditFilter,
    } = useApprovalWorkflowData({ canView });

    if (!canView) {
        return <ApprovalAccessCard />;
    }

    return (
        <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 6, mb: 8 }}>
            <Typography variant="h4" gutterBottom>
                Freigabeworkflows
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
                Vier-Augen-Prinzip für Zahlungen, Belege und Buchungen. Erstellen Sie Freigaben, bearbeiten Sie Ihre Inbox und
                prüfen Sie das Audit-Log.
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <ApprovalCreateCard form={form} onFormChange={handleFormChange} onSubmit={handleCreate} />
                </Grid>

                <Grid item xs={12} md={6}>
                    <ApprovalAuditFilterCard
                        auditFilter={auditFilter}
                        onFilterChange={handleAuditFilterChange}
                        onRefresh={refreshAudit}
                        onReset={resetAuditFilter}
                    />
                </Grid>

                <Grid item xs={12}>
                    <ApprovalInboxCard inbox={inbox} canDecide={canDecide} onDecision={handleDecision} />
                </Grid>

                <Grid item xs={12}>
                    <ApprovalRequestsCard
                        requests={requests}
                        statusFilter={statusFilter}
                        onStatusFilterChange={handleStatusFilterChange}
                    />
                </Grid>

                <Grid item xs={12}>
                    <ApprovalAuditLogCard auditEntries={auditEntries} />
                </Grid>
            </Grid>

            <ApprovalFeedbackSnackbar feedback={feedback} onClose={closeFeedback} />
        </Box>
    );
}
